import { render, staticRenderFns } from "./grid.vue?vue&type=template&id=61b0cfc8"
import script from "./grid.vue?vue&type=script&lang=js"
export * from "./grid.vue?vue&type=script&lang=js"
import style0 from "./grid.vue?vue&type=style&index=0&id=61b0cfc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CategoryItemSkeleton: require('/app/components/category/itemSkeleton.vue').default,CategoryItem: require('/app/components/category/item.vue').default})
